import api from "@/lib/api";

/**
 * Opens the PayPal-hosted subscription approval flow.
 * Backend creates the subscription and returns an approval URL; we redirect
 * the user there. PayPal will bounce them to `/settings?billing=success` when
 * they finish (or `/pricing?billing=cancel` if they bail).
 */
export async function startProCheckout() {
  const { data } = await api.post("/billing/paypal/create-subscription");
  if (!data?.approval_url) throw new Error("No approval URL from PayPal");
  window.location.assign(data.approval_url);
}

/** Ask backend to pull latest state directly from PayPal (missed-webhook safety). */
export async function reconcileFromPayPal() {
  const { data } = await api.post("/billing/paypal/reconcile");
  return data;
}

/** Cancel via PayPal API. */
export async function cancelSubscription() {
  const { data } = await api.post("/billing/paypal/cancel");
  return data;
}
